import $ from 'jquery';
import Tagify from '@yaireo/tagify';

export function initialize(context) {
    $('[data-tags]', context).each(function (n, el) {
        let me = $(el),
            options = {},
            userInput = me.attr('data-tagify-user-input') === undefined ? true : me.attr('data-tagify-user-input'),
            templates = me.attr('data-tagify-templates') === undefined ? undefined : JSON.parse(me.attr('data-tagify-templates'));
        
        if (templates) {
            for (var i in templates) {
                templates[i] = eval(templates[i]);
            }
        }

        if (me.attr('data-autocomplete')) {
            $.extend(options, {
                whitelist: JSON.parse(me.attr('data-autocomplete')),
                dropdown: {
                    enabled: 0,
                    position: 'all',
                },
                userInput: userInput,
                templates: templates
            });
        }
        
        new Tagify(el, options);
    });
}

export default { initialize };